const routeMain = () => "/cookies";

export default routeMain;
